// extracted by mini-css-extract-plugin
export default {"root":"EditListingBusinessDetailsPannel_root__A+QdH","form":"EditListingBusinessDetailsPannel_form__QgXLW","title":"EditListingBusinessDetailsPannel_title__eUC05"};